import { createRouter, createWebHistory } from 'vue-router'
import { authGuard, accessGuard, passwordChangeGuard } from './guards'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('@/pages/ChangePasswordPage.vue'),
      meta: { requiresAuth: true, right: null },
    },
    {
      path: '/',
      component: () => import('@/components/layout/AppShell.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'index',
          component: () => import('@/pages/IndexPage.vue'),
          meta: { requiresAuth: true, right: null },
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/pages/UsersPage.vue'),
          meta: { requiresAuth: true, right: 'users' },
        },
        {
          path: 'toxic',
          name: 'toxic',
          component: () => import('@/pages/ToxicPage.vue'),
          meta: { requiresAuth: true, right: 'users' },
        },
        {
          path: 'reports',
          name: 'reports',
          component: () => import('@/pages/ReportsPage.vue'),
          meta: { requiresAuth: true, right: 'reports' },
        },
        {
          path: 'logs',
          name: 'logs',
          component: () => import('@/pages/LogsPage.vue'),
          meta: { requiresAuth: true, right: 'logs' },
        },
        {
          path: 'payments',
          name: 'payments',
          component: () => import('@/pages/PaymentsPage.vue'),
          meta: { requiresAuth: true, right: 'users' },
        },
        {
          path: 'mailing',
          name: 'mailing',
          component: () => import('@/pages/MailingPage.vue'),
          meta: { requiresAuth: true, right: 'mailing' },
        },
        {
          path: 'mailing/history',
          name: 'mailing-history',
          component: () => import('@/pages/MailingsHistoryPage.vue'),
          meta: { requiresAuth: true, right: 'mailing' },
        },
        {
          // "Начислить Premium" сегменту/списку (architecture.md workstream C, решение 6,
          // task card C3). Gated by `users` (not `mailing`, unlike the campaign-tooling
          // routes above) — this mutates subscription state for potentially many users,
          // the same access class as ban/unban on the Users page, matching crm-api's
          // access_rights.users check on subscription_gift_grant/subscription_gift_revert.
          path: 'mailing/gift-grant',
          name: 'mailing-gift-grant',
          component: () => import('@/pages/GiftGrantPage.vue'),
          meta: { requiresAuth: true, right: 'users' },
        },
        {
          path: 'advertising',
          name: 'advertising',
          component: () => import('@/pages/AdvertisingPage.vue'),
          meta: { requiresAuth: true, right: 'advertising' },
        },
        {
          // Показы/переходы по рекламным объявлениям (advert_events). Gated by the
          // same `advertising` right as the page that creates those adverts — crm-api
          // checks access_rights.advertising on /api/analytics/advert_stats.
          path: 'advertising/analytics',
          name: 'advertising-analytics',
          component: () => import('@/pages/AdvertAnalyticsPage.vue'),
          meta: { requiresAuth: true, right: 'advertising' },
        },
        {
          // Promo-code CRUD (architecture.md решение 4). Gated by `settings` — same
          // access flag crm-api checks on all four promo routes (access_rights.settings,
          // see users.controller.js::getPromoCodes/addPromoCode/editPromoCode/
          // removePromoCode), not `mailing`/`advertising` like the neighboring
          // campaign-tooling pages.
          path: 'promo-codes',
          name: 'promo-codes',
          component: () => import('@/pages/PromoCodesPage.vue'),
          meta: { requiresAuth: true, right: 'settings' },
        },
        {
          path: 'referrals',
          name: 'referrals',
          component: () => import('@/pages/ReferralsPage.vue'),
          meta: { requiresAuth: true, right: null },
        },
        {
          path: 'analytics',
          name: 'analytics',
          component: () => import('@/pages/AnalyticsPageV2.vue'),
          meta: { requiresAuth: true, right: null },
        },
        {
          path: 'games',
          name: 'games',
          component: () => import('@/pages/GamesPage.vue'),
          meta: { requiresAuth: true, right: 'games' },
        },
        {
          path: 'admins',
          name: 'admins',
          component: () => import('@/pages/AdminsPage.vue'),
          meta: { requiresAuth: true, right: 'admins' },
        },
        {
          path: 'translations',
          name: 'translations',
          component: () => import('@/pages/TranslationsPage.vue'),
          meta: { requiresAuth: true, right: null },
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/pages/SettingsPage.vue'),
          meta: { requiresAuth: true, right: 'settings' },
        },
        // Only register kitchen-sink in development builds
        ...(import.meta.env.DEV
          ? [
              {
                path: 'kitchen-sink',
                name: 'kitchen-sink',
                component: () => import('@/pages/KitchenSinkPage.vue'),
                meta: { requiresAuth: true, right: null },
              },
            ]
          : []),
      ],
    },
  ],
})

router.beforeEach(authGuard)
router.beforeEach(accessGuard)
router.beforeEach(passwordChangeGuard)

export default router
